<!-- desktop template -->
<mat-expansion-panel [expanded]="isAccountsTouchpointsTab ? true : false" hideToggle id="showingTouchpoints_expansionPanel" *appIsDesktop>
  @if (!isAccountsTouchpointsTab) {
    <mat-expansion-panel-header id="touchpoints-expansion-header">
      <mat-panel-title id="touchpoints-header-container" class="title-container">
        <span class="touchpoints-header-title">
          <span id="touchpoints-title" class="title"> {{ title }} </span>
          <span id="touchpoints-header-closed"
          class="crm-industrial-font icon-keyboard-arrow-down"></span>
          <span id="touchpoints-header-opened"
          class="crm-industrial-font icon-keyboard-arrow-up"></span>
        </span>
        <div class="flex-container button-container">
          <ds-button id="seeAllButton" size="medium" type="secondary" variant="label-only" [label]="appStrings.button_seeAll" (onClick)="handleSeeAll()"
          ></ds-button>
          <ng-container *ngTemplateOutlet="newTouchpointButton"></ng-container>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
  }
  @if (!isAccountsTouchpointsTab) {
    <ds-divider></ds-divider>
  }

  @if (loading) {
    <div id="touchpoints-loading-container" class="loading">
      <ds-progress-spinner id="touchpoints-loading-spinner" progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }
  @if (!loading) {
    <div id="touchpoints-content-container">
      <div id="touchpoints-filter-container" class="filter-container">
        <div id="touchpoints-filter-flex" class="flex">
          @if (isAccountsTouchpointsTab) {
            <form id="dateRangeForm">
              <ds-date-range-picker
                id="touchpoints-date-range-picker"
                [label]="appStrings.touchpoints_week"
                label_orientation="vertical-label"
                [rangeFormGroup]="dateRangeForm"
                (startDateSelected)="onDateSelected($event)"
                (endDateSelected)="onDateSelected($event)">
              </ds-date-range-picker>
            </form>
          }
          <form id="fieldForm">
            @for (type of touchpointTypes; track type) {
              <ds-checkbox [label]="templateValues.TouchpointType[type]" [id]="'option_'+ type" [checked]="selectedTypes.includes(type)" (change)="toggleCheckbox(type)"></ds-checkbox>
            }
          </form>
        </div>
        @if (isAccountsTouchpointsTab) {
          <ng-container *ngTemplateOutlet="newTouchpointButton"></ng-container>
        }
      </div>
      @if (data.length) {
        <div id="touchpoints_list">
          <ds-table id="touchpoints-table" mat-table [dataSource]="data" [displayedColumns]="displayedColumns">
            <ng-container matColumnDef="type">
              <th id="type-header" mat-header-cell *matHeaderCellDef> {{ appStrings.touchpoints_type }} </th>
              <td mat-cell *matCellDef="let touchpoint;let i = dataIndex" [id]="'type_'+i">
                <ds-chip [id]="'type-chip_'+i" [class]="touchpoint.touchpointTypeColor" variant="filled" size="small"> {{ touchpoint.touchpointTypeLabel }} </ds-chip>
              </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th id="name-header" mat-header-cell *matHeaderCellDef> {{ appStrings.touchpoints_name }} </th>
              <td mat-cell *matCellDef="let touchpoint;let i = dataIndex" [id]="'name_'+i">
                @if (touchpoint.companyName || touchpoint.customerName) {
                  <ng-container class="ellipsis-class-companyName">
                    <div class="ellipsis-class-companyName">
                      @if (touchpoint.companyRedirect) {
                        <ds-link [id]="'name-link_'+i" [linkRef]="touchpoint.companyRedirect"> {{ touchpoint.companyName || touchpoint.customerName }} </ds-link>
                      } @else {
                        {{ touchpoint.companyName || touchpoint.customerName }}
                      }
                    </div>
                  </ng-container>
                } @else {
                  -
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="subject">
              <th id="subject-header" mat-header-cell *matHeaderCellDef> {{ appStrings.label_subject }} </th>
              <td mat-cell *matCellDef="let touchpoint;let i = dataIndex" [id]="'subject_'+i" > {{ touchpoint.subject }} </td>
            </ng-container>
            <ng-container matColumnDef="contact">
              <th id="contact-header" mat-header-cell *matHeaderCellDef> {{ appStrings.label_contact }} </th>
              <td mat-cell *matCellDef="let touchpoint;let i = dataIndex" [id]="'contact_'+i" >
                @if (touchpoint.firstContactName) {
                  <div class="text-action-container">
                    <span>{{ touchpoint.firstContactDisplay }}</span>
                    @if (touchpoint.moreContactsLength) {
                      <ds-button [id]="'more-contacts-button_'+i" class="link inline" size="medium" type="tertiary" variant="label-only" [label]="getContactButtonLabel(touchpoint)" (onClick)="showContactDetails(touchpoint)"></ds-button>
                    }
                  </div>
                } @else {
                  -
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="time">
              <th id="time-header" mat-header-cell *matHeaderCellDef> {{ appStrings.touchpoints_time }} </th>
              <td mat-cell *matCellDef="let touchpoint;let i = dataIndex" [id]="'time_'+i">
                <div class="text-action-container">
                  <span>{{ touchpoint.startDate | date : dateTimeFormat }}</span>
                  <span><p class="info-icon" [matTooltip]="getTimeTooltipText(touchpoint)"><ds-icon [id]="'time-info-icon_'+i" class="info-button" icon="info" iconStyle="material-icons-outlined"></ds-icon></p></span>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="location">
              <th id="location-header" mat-header-cell *matHeaderCellDef> {{ appStrings.touchpoints_location }} </th>
              <td mat-cell *matCellDef="let touchpoint;let i = dataIndex" [id]="'location_'+i">
                @if (touchpoint.location) {
                  <div>{{ touchpoint.location }}</div>
                } @else {
                  -
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="notes">
              <th id="notes-header" mat-header-cell *matHeaderCellDef> {{ appStrings.label_body }} </th>
              <td mat-cell *matCellDef="let touchpoint;let i = dataIndex" [id]="'notes_'+i">
                @if (touchpoint.notes) {
                  <ds-button [id]="'view-notes-button_'+i" class="link" size="medium" type="tertiary" variant="label-only" [label]="appStrings.button_view" (onClick)="showNoteDetails(touchpoint)"></ds-button>
                } @else {
                  -
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="edit">
              <th id="edit-header" mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let touchpoint;let i = dataIndex" [id]="'edit'+i">
                @if (!touchpoint.isArchived) {
                  <ds-button [id]="'edit-button_'+i" size="medium" type="tertiary" variant="label-icon" [label]="appStrings.label_edit" (onClick)="handleEditTouchpoint(touchpoint)"
                  icon="edit" iconStyle="material-icons-outlined"></ds-button>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="delete">
              <th id="delete-header" mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let touchpoint;let i = dataIndex" [id]="'delete_'+i">
                <ds-button [id]="'delete-button_'+i" size="medium" type="tertiary" variant="label-icon" [label]="appStrings.button_delete" (onClick)="deleteTouchpoint(touchpoint)"
                icon="delete" iconStyle="material-icons-outlined"></ds-button>
              </td>
            </ng-container>
            <ng-container matColumnDef="lastVisited">
              <th id="last-visited-header" mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let touchpoint;let i = dataIndex" [id]="'last-visited_'+i">
                @if (touchpoint.showLastVisited) {
                  <ds-button [id]="'last-visited-button_'+i" class="link" size="medium" type="tertiary" variant="label-only" [label]="appStrings.label_notes"
                    (onClick)="onLastVisited(touchpoint)"></ds-button>
                }
              </td>
            </ng-container>
          </ds-table>
        </div>
      } @else {
        <div id="noResults" class="no-results">
          <typography variant="mat-subtitle-1" weight="regular">
            {{ appStrings.leads_noResults }}
          </typography>
        </div>
      }
    </div>
  }
</mat-expansion-panel>

<!-- mobile template -->
<ds-paper *appIsMobile elevation="elevation_none" borderRadius="radius_S" outline="outlined" class="mobile-paper-nested-panel"
  insidePaddingTop="top-spacing_none" insidePaddingBottom="bottom-spacing_none" insidePaddingLeft="left-spacing_none" insidePaddingRight="right-spacing_none">
  <mat-expansion-panel [expanded]="isAccountsTouchpointsTab ? true : false" hideToggle class="mobile mobile-nested-panel">
    @if (!isAccountsTouchpointsTab) {
      <mat-expansion-panel-header>
        <mat-panel-title id="touchpoints-header-container" class="title-container">
          <span class="touchpoints-header-title">
            <span id="touchpoints-title" class="title"> {{ title }} </span>
          </span>
          <span id="touchpoints-header-closed"
          class="crm-industrial-font icon-keyboard-arrow-down"></span>
          <span id="touchpoints-header-opened"
          class="crm-industrial-font icon-keyboard-arrow-up"></span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    }
    <ds-divider></ds-divider>
    @if (loading) {
      <div class="loading">
        <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
      </div>
    }
    @if (!loading) {
      <div>
        <div class="filter-container">
          <ds-select [label]="appStrings.touchpoints_filters" [dropOptions]="touchpointTypesMobile" multiple="true" (selectionChange)="handleMobileFiltering()"
            [control]="filterForm.controls.selected" [label_orientation]="isAccountsTouchpointsTab ? 'vertical-label' : 'horizontal-label'"
          class="fill-width no-subscript"></ds-select>
        </div>
        @if (isAccountsTouchpointsTab) {
          <div class="date-range-container">
            <form id="dateRangeForm">
              <ds-date-range-picker
                id="touchpoints-date-range-picker"
                [label]="appStrings.touchpoints_week"
                label_orientation="vertical-label"
                [rangeFormGroup]="dateRangeForm"
                (startDateSelected)="onDateSelected($event)"
                (endDateSelected)="onDateSelected($event)"
                class="fill-width no-subscript">
              </ds-date-range-picker>
            </form>
            <div>
              <ng-container *ngTemplateOutlet="newTouchpointButton"></ng-container>
            </div>
          </div>
        }
        @if (data.length) {
          <div>
            @for (touchpoint of data; track touchpoint; let i = $index) {
              <mat-expansion-panel hideToggle class="mobile-card two-columns grey blue-border tall" [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title id="touchpoint-card-header-container" class="card-header-container">
                    <span class="icon-start">
                      <span class="card-header-icon">
                        <ds-icon id="touchpoint-card-icon" class="round-icon" [icon]="touchpoint.touchpointTypeMaterialIcon" iconStyle="material-icons-outlined"
                          [class]="touchpoint.touchpointTypeColor"
                        ></ds-icon>
                      </span>
                      <span class="card-header">
                        <span id="touchpoint-card-title" class="title"> {{ touchpoint.subject }} </span>
                        <span id="lead-card-subtitle" class="subtitle"> {{ touchpoint.startDate | date : dateTimeFormat }} </span>
                      </span>
                    </span>
                    <div class="mobile-card-header-actions">
                      @if (isAccountDashboard && !touchpoint.isArchived) {
                        <ds-button [id]="'edit-button_'+i" size="medium" type="tertiary" variant="icon-only" (onClick)="handleEditTouchpoint(touchpoint)"
                        icon="edit" iconStyle="material-icons-outlined"></ds-button>
                      }
                      <span id="touchpoints-header-closed"
                      class="crm-industrial-font icon-keyboard-arrow-down"></span>
                      <span id="touchpoints-header-opened"
                      class="crm-industrial-font icon-keyboard-arrow-up"></span>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ds-divider></ds-divider>
                <div class="content">
                  <div class="row">
                    <div class="column">
                      <typography [id]="'name_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.touchpoints_name }} </typography>
                      @if (touchpoint.companyName || touchpoint.customerName) {
                        <ng-container class="ellipsis-class-companyName">
                          <typography [id]="'name_'+i" variant="body-2" weight="medium" class="ellipsis-class-companyName">
                            @if (touchpoint.companyRedirect) {
                              <ds-link [id]="'name-link_'+i" class="dark-link" [linkRef]="touchpoint.companyRedirect"> {{ touchpoint.companyName || touchpoint.customerName }} </ds-link>
                            } @else {
                              {{ touchpoint.companyName || touchpoint.customerName }}
                            }
                          </typography>
                        </ng-container>
                      } @else {
                        -
                      }
                    </div>
                    <div class="column">
                      <typography [id]="'type_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.touchpoints_type }} </typography>
                      <typography [id]="'type_'+i" variant="body-2" weight="medium"> {{ touchpoint.touchpointTypeLabel }} </typography>
                    </div>
                  </div>
                  <div class="row">
                    <div class="column">
                      <typography [id]="'start_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.label_start }} </typography>
                      <typography [id]="'start_'+i" variant="body-2" weight="medium"> {{ touchpoint.startDate | date : dateTimeFormat }} </typography>
                    </div>
                    <div class="column">
                      <typography [id]="'end_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.label_end }} </typography>
                      <typography [id]="'end_'+i" variant="body-2" weight="medium"> {{ touchpoint.endDate | date : dateTimeFormat }} </typography>
                    </div>
                  </div>
                  <div class="row">
                    <div class="column">
                      <typography [id]="'alarm_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.label_alarm }} </typography>
                      <typography [id]="'alarm_'+i" variant="body-2" weight="medium"> {{ templateValues.AlarmType[touchpoint.alarmType] }} </typography>
                    </div>
                    <div class="column">
                      <typography [id]="'location_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.touchpoints_location }} </typography>
                      @if (touchpoint.location) {
                        <typography [id]="'location_'+i" variant="body-2" weight="medium">{{ touchpoint.location }}</typography>
                      } @else {
                        -
                      }
                    </div>
                  </div>
                  <div class="row">
                    <div class="column full-width">
                      <typography [id]="'contact_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.label_contact }} </typography>
                      <typography [id]="'contact_'+i" variant="body-2" weight="medium"> {{ touchpoint.firstContactName }} </typography>
                    </div>
                  </div>
                  <div class="row">
                    <div class="column full-width">
                      <typography [id]="'notes_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.label_body }} </typography>
                      <typography [id]="'notes_'+i" variant="body-2" weight="medium" class="break-word"> {{ touchpoint.notes }} </typography>
                    </div>
                  </div>
                  @if (isAccountDashboard) {
                    <div class="row">
                      <div class="column">
                        <ds-button [id]="'delete-button_'+i" size="medium" type="secondary" variant="label-only" [label]="appStrings.button_delete" (onClick)="deleteTouchpoint(touchpoint)">
                        </ds-button>
                      </div>
                    </div>
                  }
                  @if (touchpoint.showLastVisited) {
                    <div class="row">
                      <div class="column">
                        <ds-button [id]="'last-visited-button_'+i" size="medium" type="secondary" variant="label-only" [label]="appStrings.label_notes"
                          (onClick)="onLastVisited(touchpoint)"></ds-button>
                      </div>
                    </div>
                  }
                </div>
              </mat-expansion-panel>
            }
          </div>
        } @else {
          <div id="noResults" class="no-results">
            <typography variant="mat-subtitle-1" weight="regular">
              {{ appStrings.leads_noResults }}
            </typography>
          </div>
        }
      </div>
    }
  </mat-expansion-panel>
  @if (!isAccountsTouchpointsTab) {
    <div class="mobile-nested-panel-footer">
      <ds-divider></ds-divider>
      <div class="button-container mobile-nested-panel-footer-actions">
        <ds-button id="seeAllButton" size="medium" type="secondary" variant="label-only" [label]="appStrings.button_seeAll" (onClick)="handleSeeAll()"
        ></ds-button>
        <ng-container *ngTemplateOutlet="newTouchpointButton"></ng-container>
      </div>
    </div>
  }
</ds-paper>

<!-- common templates -->


<ng-template #newTouchpointButton>
  <ds-button size="medium" type="primary" variant="label-only" id="newTouchpointButton"
    [label]="isAccountsTouchpointsTab ? appStrings.button_addNew : appStrings.button_newTouchpoint" (onClick)="handleNewTouchpoint()">
  </ds-button>
</ng-template>

<ds-dialog
  [title]="appStrings.label_contacts"
  fullWidth="false"
  [description]="dialogContent"
  [actionButtons]="dialogButtons"
  [open]="contactsOpen$">
</ds-dialog>

<ds-dialog
  [title]="appStrings.label_body"
  fullWidth="false"
  [description]="dialogContent"
  [actionButtons]="dialogButtons"
  [open]="notesOpen$">
</ds-dialog>

<ds-dialog
  [title]="appStrings.touchpoints_deleteTouchpointTitle"
  fullWidth="false"
  [description]="appStrings.touchpoints_deleteConfirmation"
  [actionButtons]="dialogButtons"
  [open]="deleteOpen$">
</ds-dialog>
